<label
  [for]="id"
  (click)="toggle($event)"
  class="inline-flex items-center select-none group shrink-0 leading-none"
  [class.gap-3]="label"
  [class.cursor-pointer]="!disabled"
  [class.cursor-not-allowed]="disabled"
  [class.opacity-50]="disabled"
  [ngClass]="className"
>
  <!-- Hidden native input for forms/accessibility -->
  <input
    type="checkbox"
    [id]="id"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    class="sr-only"
    tabindex="-1"
  />

  <!-- Custom Checkbox Box (16px x 16px, 2px radius) -->
  <span
    class="checkbox-box w-4 h-4 min-w-4 min-h-4 rounded-xs border border-solid flex items-center justify-center shrink-0 box-border"
    [ngClass]="boxStateClasses"
  >
    <!-- Multi-selected (Indeterminate) State SVG -->
    @if (isMultiSelected) {
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0 icon-dash block">
        <path d="M2.5 6H9.5" stroke="#18181B" stroke-width="2" stroke-linecap="round"/>
      </svg>
    } @else if (checked) {
      <!-- Selected State SVG with Stroke Path for Drawing Animation -->
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0 icon-checkmark block">
        <path d="M2.5 6.2L4.8 8.7L9.5 3.3" stroke="#18181B" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }
  </span>

  <!-- Optional Label on the right (12px away) -->
  @if (label) {
    <span class="text-sm font-medium text-text-primary group-hover:text-text-primary leading-none transition-colors">
      {{ label }}
    </span>
  } @else {
    <ng-content></ng-content>
  }
</label>
